module.exports = __webpack_public_path__ + "img/model5.623f5b81.png";